import React from "react";
import {
    Box, Paper, Typography, Skeleton, Chip, Divider,
} from "@mui/material";
import { EventNote } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { localizeDateFull } from "utils/dateFormats";

const ACTION_COLOR = {
    Contacted: "primary",
    QuoteSent: "warning",
    Negotiation: "info",
    "Won/Lost": "secondary",
};

const MyFollowUpsWidget = ({ followUps = [], isLoading }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/app/crm/vendor-lead/list?tab=AssignedToMe");
    };

    return (
        <Paper
            onClick={handleClick}
            sx={{
                borderRadius: 5,
                p: 2,
                mt: 1,
                cursor: "pointer",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                "&:hover": { transform: "scale(1.01)", boxShadow: 4 },
            }}
            className="bg-purple-50 dark:bg-purple-900 shadow-md"
        >
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h6" fontWeight="bold" className="text-gray-900 dark:text-white">
                    My Follow-ups
                </Typography>
                <EventNote fontSize="large" className="text-purple-500" />
            </Box>
            <Divider sx={{ mb: 1 }} />
            {isLoading ? (
                Array.from({ length: 5 }).map((_, i) => (
                    <Skeleton key={i} height={40} sx={{ borderRadius: 2, mb: 0.5 }} />
                ))
            ) : (
                followUps.map((lead) => (
                    <Box
                        key={lead._id}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        px={1}
                        py={0.75}
                        className="rounded-lg hover:bg-purple-100 dark:hover:bg-purple-800"
                    >
                        <Box display="flex" flexDirection="column">
                            <Typography variant="body2" fontWeight={600} className="text-gray-900 dark:text-white">
                                {lead.name || lead.leadId || "N/A"}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                                Last activity:{" "}
                                {lead.lastActivityAt ? localizeDateFull(lead.lastActivityAt) : "N/A"}
                            </Typography>
                        </Box>
                        <Box display="flex" flexDirection="column" alignItems="flex-end" gap={0.5}>
                            {lead.nextfollowUpAction && (
                                <Chip
                                    label={lead.nextfollowUpAction}
                                    size="small"
                                    color={ACTION_COLOR[lead.nextfollowUpAction] ?? "default"}
                                />
                            )}
                            <Typography variant="caption" color="textSecondary">
                                {lead.nextfollowUpActionDate
                                    ? localizeDateFull(lead.nextfollowUpActionDate)
                                    : "No date"}
                            </Typography>
                        </Box>
                    </Box>
                ))
            )}
        </Paper>
    );
};

export default MyFollowUpsWidget;